import { type FC } from 'react';

import { Heading } from '@cognite/cogs-core-v11/tokens/typography/typography.tsx';

import * as S from './elements';

export const MigrateConfig: FC = () => {
  return (
    <>
      <S.MigrationRequiredMessageContainer
        direction="column"
        justifyContent="flex-start"
        gap={12}
      >
        <Heading level={2}>This feature requires a config update</Heading>
        <S.Message>
          Reach out to the InField team to update your config to the latest
          version.
        </S.Message>
      </S.MigrationRequiredMessageContainer>
    </>
  );
};
